import React from "react";

export const SampleQuestionsList = ({ questions, textColor, borderColor, inputBg, onQuestionClick }) => {
  const defaultQuestions = [
    "What services do you offer?",
    "How does pricing work?",
    "Tell me about your AI solutions",
    "Do you offer customer support?",
  ];
  const displayQuestions = questions?.length > 0 ? questions : defaultQuestions;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {displayQuestions.map((question, index) => (
        <div
          key={index}
          style={{
            backgroundColor: inputBg,
            // border: `1px solid ${borderColor}`,
            borderRadius: 8,
            padding: "10px 14px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          onClick={() => onQuestionClick && onQuestionClick(question)}
        >
          <span style={{ fontSize: 13, fontWeight: 500, color: textColor }}>
            {question}
          </span>
          <span style={{ color: textColor, opacity: 0.6, fontSize: 12 }}>→</span>
        </div>
      ))}
    </div>
  );
};